import { Stack } from "@fluentui/react";
import React from "react";
import { IconName } from "../../../../../styles/icons";
import { Icon } from "../../../../Icon/Icon";
import { TruncatedText } from "../../../../TruncatedText/TruncatedText";
import { iconStyles, textStyles } from "./DrawerHeaderStatus.styles";

export interface DrawerHeaderStatusProps {
    /**
     * Name of the icon to render
     */
    readonly iconName?: IconName;
    /**
     * Alignment of the status inside the column. Defaults to start.
     */
    readonly statusAlignment?: "start" | "center" | "end";
    /**
     * Weight override for text
     */
    readonly textWeightOverride?: "bold" | "semi-bold";
    /**
     * Style override for text
     */
    readonly textVariant?: "bodySecondaryText";
    /**
     * Text displayed in the column.
     */
    readonly children?: string;
}

const statusIconSize = "16px";

export const DrawerHeaderStatus: React.FC<DrawerHeaderStatusProps> = ({
    iconName,
    statusAlignment = "start",
    textWeightOverride,
    textVariant,
    children
}) => (
    <Stack horizontal={true} horizontalAlign={statusAlignment} verticalAlign={"center"}>
        {iconName && (
            <Stack verticalAlign="center" styles={iconStyles()}>
                <Icon
                    iconName={iconName}
                    size={statusIconSize}
                />
            </Stack>
        )}
        <Stack styles={textStyles()}>
            <TruncatedText weightOverride={textWeightOverride} variant={textVariant}>{children}</TruncatedText>
        </Stack>
    </Stack>
);
